import { render } from "./DsoStep3Registration.vue?vue&type=template&id=a5ccb9ae&scoped=true"
import script from "./DsoStep3Registration.vue?vue&type=script&lang=js"
export * from "./DsoStep3Registration.vue?vue&type=script&lang=js"

import "./DsoStep3Registration.vue?vue&type=style&index=0&id=a5ccb9ae&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ccb9ae"]])

export default __exports__